import React from "react";
import { Link } from "react-router-dom";
import classnames from "classnames";
import { Badge } from "reactstrap";
import { ChevronRight } from "react-feather";
import { history } from "pixacomHistory";
import axios from "axios";

import storage from "components/Pixacom/storage";
import navigationConfig from "configs/navigationConfig";

import SideMenuGroup from "./SideMenuGroup";

const PRAGUE = 8;

const isItemTypeOfNode = ({ children } = {}) =>
  Array.isArray(children) && !!children?.length;

class SideMenuContent extends React.Component {
  constructor(props) {
    super(props);

    this.parentArr = [];

    this.collapsedPath = null;
    this.redirectUnauthorized = () => {
      history.push("/login");
    };
  }
  state = {
    flag: true,
    isHovered: false,
    activeGroups: [],
    currentActiveGroup: [],
    tempArr: [],
    isPrague: false,
  };

  handleGroupClick = (item = {}, idParent = null) => {
    const { id, type = "" } = item;
    let open_group = this.state.activeGroups;
    let active_group = this.state.currentActiveGroup;
    let temp_arr = this.state.tempArr;
    const isNode = isItemTypeOfNode(item);
    const isLeaf = !isNode;
    // Active Group to apply sidebar-group-active class
    if (isLeaf && idParent === null) {
      active_group = [];
      temp_arr = [];
    } else if (isLeaf && idParent !== null) {
      active_group = [];
      if (temp_arr.includes(idParent)) {
        temp_arr.splice(temp_arr.indexOf(idParent) + 1, temp_arr.length);
      } else {
        temp_arr = [];
        temp_arr.push(idParent);
      }
      active_group = temp_arr.slice(0);
    } else if (isNode && idParent === null) {
      temp_arr = [];
      temp_arr.push(id);
    } else if (isNode && idParent !== null) {
      if (active_group.includes(idParent)) {
        temp_arr = active_group.slice(0);
      }
      if (temp_arr.includes(id)) {
        // temp_arr.splice(temp_arr.indexOf(id), 1)
        temp_arr.splice(temp_arr.indexOf(id), temp_arr.length);
      } else {
        temp_arr.push(id);
      }
    } else {
      temp_arr = [];
    }

    if (isNode) {
      // If open group does not include clicked group item
      if (!open_group.includes(id)) {
        // Get unmatched items that are not in the active group
        let temp = open_group.filter(function (obj) {
          return active_group.indexOf(obj) === -1;
        });
        // Remove those unmatched items from open group
        if (temp.length > 0 && !open_group.includes(idParent)) {
          open_group = open_group.filter(function (obj) {
            return !temp.includes(obj);
          });
        }
        if (open_group.includes(idParent) && active_group.includes(idParent)) {
          open_group = active_group.slice(0);
        }
        // Add group item clicked in open group
        if (!open_group.includes(id)) {
          open_group.push(id);
        }
      } else {
        // If open group includes click group item, remove it from open group
        open_group.splice(open_group.indexOf(id), 1);
      }
    }
    if (isLeaf) {
      open_group = active_group.slice(0);
    }

    this.setState({
      activeGroups: open_group,
      tempArr: temp_arr,
      currentActiveGroup: active_group,
    });
  };

  initRender = (parentArr) => {
    this.setState({
      activeGroups: parentArr.slice(0),
      //currentActiveGroup: parentArr.slice(0),
      flag: false,
    });
  };

  async updateIsPrague() {
    if (this.props.user && this.props.user.region) {
      const center = await this.getCenter(this.props.user.region);

      this.setState({ isPrague: center === PRAGUE });
    }
  }

  async componentDidMount() {
    this.initRender(this.parentArr[0] ? this.parentArr[0] : []);

    await this.updateIsPrague();
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.activePath !== this.props.activePath) {
      if (this.collapsedMenuPaths !== null) {
        this.props.collapsedMenuPaths(this.collapsedMenuPaths);
      }

      this.initRender(
        this.parentArr[0] ? this.parentArr[this.parentArr.length - 1] : []
      );
    }
    
    // jen při změně regionu
    if (prevProps.user?.region !== this.props.user?.region) {
      await this.updateIsPrague();
    }
  }

  async getCenter(id) {
    try {
      const { status, data } = await axios.get(`/api/data/dsacenter/${id}`, {
        headers: { Authorization: `Bearer ${storage.getItem("token")}` },
      });

      if (status >= 200 && status <= 299) {
        return data.code;
      }
    } catch (err) {}
  }

  normalizePath = (p = "") => {
    if (!p) return "";
    if (p === "/") return "/";          // root necháme
    return p.replace(/\/+$/, "");       // ostatním ořežeme trailing slash
  };

  isActive = (item) => {
    const cur =
      this.normalizePath(this.props.activePath || window.location.pathname);

    // filterBase (parametrické routy)
    if (item.filterBase) {
      return cur.startsWith(this.normalizePath(item.filterBase));
    }

    // navLink + podstránky
    if (item.navLink) {
      const link = this.normalizePath(item.navLink);
      if (cur === link) return true;
      if (cur.startsWith(link + "/")) return true;
    }

    // parentOf jako prefixy
    if (Array.isArray(item.parentOf) && item.parentOf.length) {
      return item.parentOf.some((base) =>
        cur.startsWith(this.normalizePath(base))
      );
    }

    return false;
  };

  render() {
    // Loop over sidebar items
    // eslint-disable-next-line

    const menuItems = navigationConfig.map((item) => {
      const CustomAnchorTag = item.type === "external-link" ? `a` : Link;

      const isNode = Array.isArray(item?.children) && !!item?.children?.length;
      const isLeaf = !isNode;

      let renderItem = (
        <li
          className={classnames("nav-item", {
            "has-sub": isNode,
            open: this.state.activeGroups.includes(item.id),
            "sidebar-group-active": this.state.currentActiveGroup.includes(
              item.id
            ),
            hover: this.props.hoverIndex === item.id,
            active: isLeaf && this.isActive(item),
            disabled: item.disabled,
          })}
          key={item.id}
          onClick={(e) => {
            e.stopPropagation();
            if (isLeaf) {
              this.props.handleActiveItem(item.navLink);
              this.handleGroupClick(item, null);
              if (this.props.deviceWidth <= 1200 && isLeaf) {
                this.props.toggleMenu();
              }
            } else {
              this.handleGroupClick(item, null);
            }
          }}
        >
          <CustomAnchorTag
            to={
              item.filterBase
                ? item.filterBase
                : item.navLink && isLeaf
                  ? item.navLink
                  : ""
            }
            href={item.type === "external-link" ? item.navLink : ""}
            className={`d-flex ${
              item.badgeText
                ? "justify-content-between"
                : "justify-content-start"
            }`}
            onMouseEnter={() => {
              this.props.handleSidebarMouseEnter(item.id);
            }}
            onMouseLeave={() => {
              this.props.handleSidebarMouseEnter(item.id);
            }}
            key={item.id}
            onClick={(e) => {
              return isNode ? e.preventDefault() : "";
            }}
            target={item.newTab ? "_blank" : undefined}
          >
            <div className="menu-text">
              {item.icon}
              <span className="menu-item font-weight-bold menu-title">
                {item.title}
              </span>
            </div>

            {item.badge ? (
              <div className="menu-badge">
                <Badge color={item.badge} className="mr-1" pill>
                  {item.badgeText}
                </Badge>
              </div>
            ) : (
              ""
            )}

            {isNode ? (
              <ChevronRight className="menu-toggle-icon" size={13} />
            ) : (
              ""
            )}
          </CustomAnchorTag>

          {isNode ? (
            <SideMenuGroup
              group={item}
              handleGroupClick={this.handleGroupClick}
              activeGroup={this.state.activeGroups}
              handleActiveItem={this.props.handleActiveItem}
              activeItemState={this.props.activeItemState}
              handleSidebarMouseEnter={this.props.handleSidebarMouseEnter}
              activePath={this.props.activePath}
              hoverIndex={this.props.hoverIndex}
              initRender={this.initRender}
              parentArr={this.parentArr}
              triggerActive={undefined}
              currentActiveGroup={this.state.currentActiveGroup}
              permission={this.props.permission}
              currentUser={this.props.currentUser}
              currentUserRoles={this.props.currentUserRoles}
              redirectUnauthorized={this.redirectUnauthorized}
              collapsedMenuPaths={this.props.collapsedMenuPaths}
              toggleMenu={this.props.toggleMenu}
              deviceWidth={this.props.deviceWidth}
              user={this.props.user}
              isPrague={this.state.isPrague}
            />
          ) : (
            ""
          )}
        </li>
      );

      if (
        item.navLink &&
        item.collapsed !== undefined &&
        item.collapsed === true
      ) {
        this.collapsedPath = item.navLink;
        this.props.collapsedMenuPaths(item.navLink);
      }

      if (
        (!item.onlyPrague || (item.onlyPrague && this.state.isPrague)) &&
        (isNode || item.type === "external-link" || isLeaf) &&
        ((item.permissions &&
          (item.permissions.includes(this.props.currentUser) ||
            (this.props.currentUserRoles &&
              item.permissions.some((r) =>
                this.props.currentUserRoles.includes(r)
              )))) ||
          item.permissions === undefined)
      ) {
        return renderItem;
      }

      if (
        (!item.onlyPrague || (item.onlyPrague && this.state.isPrague)) &&
        isLeaf &&
        item.navLink === this.props.activePath &&
        (!item.permissions.includes(this.props.currentUser) ||
          (this.props.currentUserRoles &&
            !item.permissions.some((r) =>
              this.props.currentUserRoles.includes(r)
            )))
      ) {
        return this.redirectUnauthorized();
      }
    });

    return <React.Fragment>{menuItems}</React.Fragment>;
  }
}
export default SideMenuContent;
